import React, { Component, cloneElement, useState } from 'react';
import { List, CreateButton, RefreshButton, TopToolbar, Datagrid, TextField, DateField, ShowButton, Filter, TextInput, SelectInput, useTranslate,DateInput } from 'react-admin';
// import { DateInput } from 'react-admin-date-inputs';
// import { DateInput } from 'react-admin-date-inputs';
import { Scrollbars } from 'react-custom-scrollbars';
import Spinner from '../spinner';
import myDataProvider from '../myRestProvider';
import { unparse as convertToCSV } from 'papaparse/papaparse.min';
import Modal from 'react-responsive-modal';

const selectInputStyle = {
    width: 200,
};

const InAppFilter = (props) => (
    <Filter {...props}>
        <TextInput  source="text"/>
        <TextInput  source="purpose"/>
        <SelectInput style={selectInputStyle} source="type" choices={[
            { id: 'Country', name: 'All Retailers' },
            { id: 'Business', name: 'A set of Retailers' },
        ]}
        />
        <DateInput source="from_date"  
        // label="SMS date from"  
        />
        <DateInput source="to_date"  
        // label="SMS date to"  
        />
    </Filter>
);

// const topToolbarStyle = {
//     zIndex: 2,
//     display: 'inline-block',
//     float: 'right',
// };

const textFieldStyle = {
    display: 'block',
    width: 200,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',

};

const ListActions = ({ resource, basePath, filterValues, total, maxResults, currentSort, exporter, permanentFilter, showFilter, displayedFilters, filters }) => {
    return (
        <TopToolbar>
            {filters && cloneElement(filters, {
                resource,
                showFilter,
                displayedFilters,
                filterValues,
                context: 'button',
            })}
            <CreateButton basePath={basePath} />
            <RefreshButton />
        </TopToolbar>
    )
}

const SendMessageList = (props) => {
    const [modalShow, setModalShow] = useState(false);
    const [modalMsg, setModalMsg] = useState('');
    const translate = useTranslate();



   const  exporter = (data) => {
        const msg = data[0].message;
       
        setModalShow(true);
        setModalMsg(msg);
    }

    const onClose = () => {
        setModalShow(false);
    }

    
        // const {  permissions } = this;
        return (
            <React.Fragment>
                <Scrollbars className="scroll-container" >
                    <List {...props} exporter={exporter} sort={{ field: 'created_at', order: 'DESC' }}  filters={<InAppFilter />} title={translate('resources.sms_blasts.fields.send_msg')} actions={<ListActions  />}>
                        <Datagrid rowClick="show" bulkActionButtons={false}>
                            <TextField  source="purpose" style={textFieldStyle} allowEmpty />
                            <TextField  source="text" style={textFieldStyle} allowEmpty />
                            <TextField  source="target_type" sortable={false} allowEmpty />
                            {/* <DateField label={'Created at'} source="created_at" allowEmpty /> */}
                            <DateField  source="created_at" showTime />
                            <ShowButton />
                        </Datagrid>
                    </List>
                </Scrollbars>
                {
                    modalShow &&
                    <Modal open={modalShow} onClose={onClose} center>
                        <h3>{modalMsg}</h3>
                    </Modal>
                }
            </React.Fragment>
        )
    
}

export default SendMessageList;